/* eslint-disable */
import Router from 'vue-router'

import LandingHeader from '@/components/public/c25LandingHeader'
import Dashboard from '../components/p2Dashboard/p2Dashboard'
import ChangeLog from '../components/public/p8Changelog'
import p2s1MyOrganizations from '../components/p2Dashboard/p2s1MyOrganizations/p2s1MyOrganizations'
import p7Login from '../components/public/p7Login'

let router = new Router({
  routes: [
    {
      path: '/changelog',
      component: ChangeLog
    },
    {
      path: '/mobile',
      redirect: '/about~',
    },
    {
      path: '/automatic_user_creation/:newUserEmail/:newUserPassword',
      name: 'automaticUserCreation',
      component: p7Login,
      meta: {
        breadcrumb: 'Login'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: p7Login,
      meta: {
        breadcrumb: 'Login'
      }
    },
    {
      path: '/doghouse/:orgUid?/:sysUid?/:objectUid?/:objectAttributeUid?',
      name: 'p4Doghouse',
      props: true,
      component: () => import('@/components/public/p4Doghouse'),
      meta: {
        requiresAuth: true,
        breadcrumb: 'Doghouse'
      },
    },
    // ------------------------------------------ User Console ----------------------------------
    {
      path: '/dashboard',
      name: 'Dashboard',
      // alias: '',
      component: Dashboard,
      props: true,
      // meta: {description: 'Dashboard'}
      meta: {
        requiresAuth: true,
        breadcrumb: 'Dashboard'
      },
      children: [{
        path: ':subModals',
        children: [{
          path: 'org/:orgUid?', component: Dashboard,
          children: [{
            path: 'sys/:sysUid?', component: p2s1MyOrganizations,
            children: [{
              path: 'obj/:objUid?', component: p2s1MyOrganizations,
              children: [{
                path: 'obj_atr/:objAtrUid?', component: p2s1MyOrganizations,
              }]
            }]
          },
          {
            path: 'ngp/:ngpUid?', 
            component: p2s1MyOrganizations,
          },
          {
            path: 'usr/:usrUid?', 
            component: p2s1MyOrganizations,
          }]
        }]
      }]
    },
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/:subModals?',
      name: 'LandingHeader',
      props: true,
      component: LandingHeader,
    }
  ],
  // set mode to ‘history’ to remove the hash from the URLs
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  //p7login handles pushing the redirect URL on sign in
  if (to.name === 'Login' && from.name !== 'Login' && from.name !== 'LandingHeader' && from.name !== null) {
    window.G_redirectUrl = from.path;
  }
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js